<script>

export default {
    methods: {
        padTo2Digits: function (num) {
            return num.toString().padStart(2, '0')
        },

        formatDate: function (date) {
            if (!date) {
                return null
            }
            try {
                return [
                    date.getFullYear(),
                    this.padTo2Digits(date.getMonth() + 1),
                    this.padTo2Digits(date.getDate()),
                    ].join('-')
            }
            catch (e) {
                return date
            }
            
        },

        formatNumberWithSpaces (number) {
            return new Intl.NumberFormat('ru-RU').format(number)
        }
    }
}
</script>